import { render, staticRenderFns } from "./ConvertAllDuplicatesModal.vue?vue&type=template&id=517b6bcc&"
import script from "./ConvertAllDuplicatesModal.vue?vue&type=script&lang=ts&"
export * from "./ConvertAllDuplicatesModal.vue?vue&type=script&lang=ts&"
import style0 from "./ConvertAllDuplicatesModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports